import type { FlowStep } from './flow-steps.tsx';

interface FindStepParams<State> {
  id: string;
  steps: Record<string, FlowStep<State>>;
}

export function findStep<State>({ id, steps }: FindStepParams<State>): FlowStep<State> {
  const node = steps[id];
  if (node === undefined) {
    throw new Error(`Flow node '${id}' not found`);
  }
  return node;
}
